import { ApiKeyView } from '@/types/permissions/api-key';
import { LinksView } from '@/types/permissions/links';
import { RegistryView } from '@/types/permissions/registry';
import { SuperRosterView } from '@/types/permissions/super-roster';

import { BankView } from './bank';
import { BeachDelegationView, BeachRefereeView, BeachStatisticsView, BeachView } from './beach';
import { ClubView } from './club';
import { CommunicationView } from './communication';
import { CompetitionsView } from './competition';
import { DashboardView } from './dashboard';
import { DelegatesView } from './delegates';
import { DirectoryView } from './directory';
import { FamousPeopleView } from './famous-people';
import { LicenseView } from './license';
import { ListView } from './list';
import { MembershipFeeView } from './membership-fee';
import { NsaView } from './nsa';
import { PersonalSettingsView } from './personal-settings';
import { PlayerView } from './player';
import { QualificationView } from './qualification';
import { RefereeView } from './referee';
import { RosterView } from './roster';
import { SportsFieldView } from './sports-field';
import { SurveyView } from './survey';
import { TransferView } from './transfer';
import { UserView } from './user';
import { VotingView } from './voting';

// key = route name, value = tag from figma
// keep aplhabetical order
export enum ModuleTag {
  API_KEY = 'api',
  BANK = 'bank',
  BEACH = 'beach',
  BEACH_REFEREE = 'beach-referee',
  BEACH_DELEGATION = 'beach-delegation',
  BEACH_STATS = 'beach-stats',
  CLUBS = 'club',
  COMMUNICATION = 'communication',
  COMPETITIONS = 'competition',
  DASHBOARD = 'dashboard',
  DELEGATES = 'delegation',
  DIRECTORY = 'address-book',
  FAMOUS_PEOPLE = 'famousperson',
  LICENSE = 'license',
  LISTS = 'list',
  MEMBERSHIP_FEES = 'donation',
  NSA = 'nsa',
  PERSONAL_SETTINGS = 'personal-settings',
  PLAYER = 'player',
  USER = 'user',
  QUALIFICATION = 'qualification',
  REFEREE = 'referee',
  ROSTER = 'roster',
  SPORTSFIELD = 'sportsfield',
  SURVEY = 'survey',
  TRANSFERS = 'transfer',
  VOTING = 'voting',
  REGISTRY = 'registry',
  SUPER_LINKS = 'super-link',
  SUPER_ROSTER = 'super-roster',
  SUPER_USER = 'superuser',
}

export const permissions = {
  [ModuleTag.API_KEY]: ApiKeyView,
  [ModuleTag.BANK]: BankView,
  [ModuleTag.BEACH]: BeachView,
  [ModuleTag.BEACH_REFEREE]: BeachRefereeView,
  [ModuleTag.BEACH_DELEGATION]: BeachDelegationView,
  [ModuleTag.BEACH_STATS]: BeachStatisticsView,
  [ModuleTag.CLUBS]: ClubView,
  [ModuleTag.COMMUNICATION]: CommunicationView,
  [ModuleTag.COMPETITIONS]: CompetitionsView,
  [ModuleTag.DASHBOARD]: DashboardView,
  [ModuleTag.DELEGATES]: DelegatesView,
  [ModuleTag.DIRECTORY]: DirectoryView,
  [ModuleTag.FAMOUS_PEOPLE]: FamousPeopleView,
  [ModuleTag.LICENSE]: LicenseView,
  [ModuleTag.LISTS]: ListView,
  [ModuleTag.MEMBERSHIP_FEES]: MembershipFeeView,
  [ModuleTag.NSA]: NsaView,
  [ModuleTag.PERSONAL_SETTINGS]: PersonalSettingsView,
  [ModuleTag.USER]: UserView,
  [ModuleTag.PLAYER]: PlayerView,
  [ModuleTag.QUALIFICATION]: QualificationView,
  [ModuleTag.REFEREE]: RefereeView,
  [ModuleTag.ROSTER]: RosterView,
  [ModuleTag.SPORTSFIELD]: SportsFieldView,
  [ModuleTag.SURVEY]: SurveyView,
  [ModuleTag.TRANSFERS]: TransferView,
  [ModuleTag.VOTING]: VotingView,
  [ModuleTag.REGISTRY]: RegistryView,
  [ModuleTag.SUPER_LINKS]: LinksView,
  [ModuleTag.SUPER_ROSTER]: SuperRosterView,
  [ModuleTag.SUPER_USER]: {},
} as const;

export const getPermissionTag = <T extends keyof TPermissions>(module: T, view: keyof TPermissions[T]) => {
  return `${module}${permissions[module][view]}`;
};

export type TPermissions = typeof permissions;
export interface IPermission<T extends keyof TPermissions> {
  moduleName: T;
  view: keyof TPermissions[T];
}

export * from './api-key';
export * from './bank';
export * from './beach';
export * from './club';
export * from './communication';
export * from './competition';
export * from './dashboard';
export * from './delegates';
export * from './directory';
export * from './famous-people';
export * from './license';
export * from './list';
export * from './membership-fee';
export * from './nsa';
export * from './personal-settings';
export * from './player';
export * from './qualification';
export * from './referee';
export * from './roster';
export * from './sports-field';
export * from './survey';
export * from './transfer';
export * from './voting';
